import { css } from '@emotion/css';
import React, { ChangeEvent } from 'react';
import { useTranslation } from 'react-i18next';
import { AspectRatioImage } from 'src/components/shared/AspectRatioImage';
import { Construction } from 'src/models/resort/Construction';
import { getConstructionTheme } from '../ConstructionTheme';

interface ReportConstListItemProps {
  construction: Construction;
  onChange: (resortId: string) => void;
}

export const ReportConstListItem: React.FC<ReportConstListItemProps> = ({
  construction,
  onChange
}) => {
  const { t } = useTranslation('resort');

  const handleChange = (ev: ChangeEvent<HTMLInputElement>) => {
    const resortId = ev.target.value as string;
    onChange(resortId);
  };

  const constructionTheme = getConstructionTheme(t, construction);

  return (
    <li
      className={css`
        list-style-type: none;
        margin: 8px 0 16px;
      `}
    >
      <label
        className={css`
          display: block;
          background: #fffff2;
          border-radius: 8px;
          padding: 16px 12px;
          .radio-container {
            display: flex;
            align-items: center;
            margin: 0 0 12px;
          }
          .resort-title {
            font-size: 16px;
            color: #493a31;
            text-align: left;
            text-align: start;
          }
          input[type='radio'] {
            flex: 0 0 auto;
            appearance: none;
            border-radius: 50%;
            width: 1.5em;
            height: 1.5em;
            outline: none;
            border: 1px solid #897a66;
            transition: background-color 0.1s;
            padding: 3px;
            margin: 0 12px 0 0;

            &:checked {
              background-clip: content-box;
              background-color: #50b163;
            }
          }
          .resort-info {
            margin: 0 24px 0 36px;
          }
          .images {
            display: flex;
            flex-wrap: wrap;
          }
          .image {
            width: 40%;
            max-width: 200px;
            margin-right: 8px;
          }
        `}
      >
        <div className="radio-container">
          <input
            type="radio"
            name="resort-item"
            value={construction.resortId}
            onChange={handleChange}
          />
          <p className="resort-title">{constructionTheme}</p>
        </div>

        <div className="resort-info">
          <div className="images">
            {construction.resortImages.map((image, index) => (
              <div key={index} className="image">
                <AspectRatioImage src={image} width={960} height={540} />
              </div>
            ))}
          </div>
        </div>
      </label>
    </li>
  );
};
